module.exports = __webpack_public_path__ + "static/media/tiempo.1bfbccf0.svg";